<template>
  <!-- <b-row class="text-center"> -->
    <b-col md="3" sm="3" xl="3">
      <b-card @click="detail(agent)" :style="{ cursor: 'pointer'}">
        <b-badge variant="success" v-if="!agent.ms == 0 ">온라인 ({{agent.ms}} ms)</b-badge>
        <b-badge v-else>오프라인</b-badge>
        <p class="ml-2 font-weight-bold">{{agent.name || '-'}}</p>
        <hr>
        <h6>{{agent.ip_addr}}<br></h6>
        <b-badge variant="info">확인 : {{agent.total_scan}}</b-badge>
        <br>
        <b-badge v-if="agent.total_detect" variant="danger">탐지 : {{agent.total_detect}}</b-badge>
        <!-- <i v-if="agent.scanning" class="fa fa-refresh fa-spin"></i> -->
        <hr>
        <p>
          <b-spinner v-if="agent && agent.scanning" small type="grow"></b-spinner>
          <span class="font-weight-bold ml-1">
            {{agent.scanning ? '점검중' : '대기중'}}
          </span>
        </p>
      </b-card>
    </b-col>
  <!-- </b-row> -->
</template>
<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>
